import { authHeader } from "../helpers/auth-header";
import axios from 'axios';

const getDashboard = () => {
    return axios.get('/api/dashboard', {headers: authHeader()})
        .then(res => {
            return res.data;
        });
}

const readExhibitionState = () => {
    return axios.get('/api/ReadExhibitionState', { headers: authHeader() })
        .then(res => {
            return res.data;
        });
}

const setPowerManagement = (action) => {
    return axios.patch('/api/dashboard/' + action, {} , { headers: authHeader() } )
        .then(res => {
            return res.data;
        })
}

const getDashboardAction = (action) => {
    return axios.get('/api/dashboard/' + action, { headers: authHeader() } )
        .then(res => {
            return res.data;
        })
}

const setLantick = (action) => {
    return axios.get('/api/dashboard/' + action , { headers: authHeader() } )
        .then(res => {
            return res.data;
        })
}

const setDaliScenes = (action) => {
    return axios.get('/api/dashboard/' + action, { headers: authHeader() } )
        .then(res => {
            return res.data
        });
}

const setDaliEsSystemScenes = (action) => {
    return axios.get('/api/dashboard/' +  action, { headers: authHeader() })
        .then((res) => {
            return res.data
        }
    )
}

const setDeviceGroup = (action) => {
    return axios.get('/api/dashboard/' + action, { headers: authHeader() } )
        .then(res => {
            return res.data
        });
}

const changeVolume = (changeModel) => {
    return axios.get('/api/dashboard/changeVolume', {
        params: {
            id: changeModel['id'] ? changeModel['id'] : null,
            volume: changeModel['volume'] !== undefined ? changeModel['volume'] : null,
            mute: changeModel['mute'] !== undefined ? changeModel['mute'] : null,
        },
        headers: authHeader()
    });
}

const volumeControl =(response) => {
    return axios.get('/api/dashboard/' + response, {  headers: authHeader() })
        .then(res => {
            return res.data
        });
}

const changeExhibitionScenario = (changeScenario) => {
    return axios.get('/api/' + changeScenario, { headers: authHeader() })
        .then(res => {
            return res.data
        })
}

const  logVisitNextStep = (tag) => {
    return axios.patch(`/api/dashboard/LogVisitNextStep/${tag}`, {}, { headers: authHeader() })
        .then(res => {
            return res.data
        })
};

const logVisitPrevStep = (tag) => {
    return axios.patch(`api/dashboard/LogVisitPrevStep/${tag}`, {}, { headers: authHeader() })
        .then(res => {
            return res.data
        })
};

const closeVisit = (tag) => {
    return axios.patch(`/api/dashboard/CloseVisit/${tag}`, {}, { headers: authHeader() })
        .then(res => {
            return res.data
        })
};

const createVisit = (model) => {
    return axios.post(`api/dashboard/CreateRfidVisit`, model, { headers: authHeader() })
        .then(res => {
            return res.data
        })
};

const getAudioPlayersList = (deviceUrl) => {
    return axios.get(`http://${deviceUrl}/MZAP/API/v1/rest/GetPlayers`)
        .then(res => {
            return res.data
        })
};

const muteAudioPlayer = (deviceUrl, playerId, value) => {
    return axios.get(`http://${deviceUrl}/MZAP/API/v1/rest/SetPlayerMute?playerId=${playerId}&mute=${value}`)
        .then(res => {
            return res.data
        })
};

const setDmxPxmScenes = (action) => {
    return axios.get('/api/dashboard/' + action, { headers: authHeader() } )
        .then(res => {
            return res.data
        });
}

const getNodeRedRequest = (url, isAuthorize = false) => {
    return axios.get(url, { headers: isAuthorize ? authHeader() : "" })
        .then(res => {
            return res.data
        })
}


export const dashboardService = {
    getDashboard,
    getDashboardAction,
    readExhibitionState,
    setPowerManagement,
    setDaliScenes,
    setDaliEsSystemScenes,
    setDmxPxmScenes,
    setDeviceGroup,
    setLantick,
    changeVolume,
    volumeControl,
    changeExhibitionScenario,
    createVisit,
    logVisitNextStep,
    logVisitPrevStep,
    closeVisit,
    getAudioPlayersList,
    muteAudioPlayer,
    getNodeRedRequest
};
